<script setup lang="ts">
    import { useDisplay } from 'vuetify';
    import { appScale } from '@/composables/appScale';
    import { useScaledDisplay } from '@/composables/useScaledDisplay';
    import { useWindowResize } from '@/composables/useWindowResize';
    import { useMenuStore } from '@/stores/menu';

    const NARROW_BREADCRUMB_MAX_VIRTUAL_WIDTH = 780;

    const menuStore = useMenuStore();
    const { t } = useI18n();
    const display = useDisplay();
    const scaledDisplay = useScaledDisplay();
    const { isLandscapeMobile } = useWindowResize();

    const virtualWidth = computed(() => {
        const scale = appScale.value;
        const w = display.width.value;
        return scale > 0 && scale < 1 ? w / scale : w;
    });

    const hideMenuSectionBreadcrumb = computed(() => virtualWidth.value < NARROW_BREADCRUMB_MAX_VIRTUAL_WIDTH);

    const visibleBreadcrumbs = computed(() => {
        const items = menuStore.breadcrumbs;
        if (!hideMenuSectionBreadcrumb.value || items.length <= 1) {
            return items;
        }
        return items.slice(1);
    });

    const shortToolUserDocumentsBreadcrumb = computed(() => scaledDisplay.xs.value && !isLandscapeMobile.value);

    function breadcrumbLabel(item: { title?: string; disabled?: boolean }): string {
        const key = item.title ?? '';
        if (key === 'menu.toolUserDocuments' && shortToolUserDocumentsBreadcrumb.value) {
            return t('menu.toolUserDocumentsShort');
        }
        return t(key);
    }
</script>

<template>
    <v-breadcrumbs :items="visibleBreadcrumbs" class="px-0 py-0" color="tbGreen" density="compact">
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item :disabled="item.disabled">{{ breadcrumbLabel(item) }}</v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
</template>
